<template>
	<form class="event" @submit.prevent="submitEvent">
		<div class="event__product-image" v-show="isShowImageModal">
			<div
				class="event__product-image__background"
				@click="hideImageModal"
			></div>
			<div class="event__product-image__image">
				<img :src="imageModalSrc" alt="이미지 미리보기" />
				<button
					@click="hideImageModal"
					type="button"
					class="event__product-image__modal-close"
				>
					<i class="fa fas fa-times"></i>
				</button>
			</div>
		</div>
		<table>
			<tr>
				<td>
					<RegisterTable title="기본 정보">
						<RegisterRow title="상태">
							<RadioList
								v-model="isDisplay"
								:radioList="isDisplayList"
							/>
						</RegisterRow>
						<RegisterRow title="유형">
							<RadioList
								v-model="isHidden"
								:radioList="isHiddenList"
							/>
						</RegisterRow>
						<RegisterRow title="이벤트 번호">
							<p>{{ idEvent === null ? '자동생성' : idEvent }}</p>
						</RegisterRow>

						<RegisterRow title="이벤트명">
							<label>
								<input v-model="eventTitle" type="text" />
							</label>
						</RegisterRow>

						<RegisterRow title="이벤트 부가설명">
							<label>
								<input
									v-model="eventDesc"
									type="text"
									maxlength="30"
									placeholder="이벤트 리스트에 노출될 설명을 입력해주세요."
									class="event-input--large"
								/>
							</label>
							<span>
								{{ getDescLength }} / 30 (25자 이상시
								말줄임(...) 될 수 있습니다.)
							</span>
						</RegisterRow>

						<RegisterRow title="이벤트 기간">
							<DateRange
								v-model="eventPeriod"
								@input="onInputEventPeriod"
							/>
						</RegisterRow>

						<RegisterRow title="당첨자 발표일">
							<DateBox v-model="winnerIssueOn" type="date" />
						</RegisterRow>

						<RegisterRow title="마감일">
							<DateBox v-model="reviewEndAt" type="date" />
						</RegisterRow>

						<RegisterRow title="당첨인원">
							<input
								v-model="winnerLimit"
								type="text"
								name="winnerLimit"
								aria-label="당첨인원"
								placeholder="당첨인원"
							/>
						</RegisterRow>
						<RegisterRow title="최대 참여 가능 인원">
							<input
								v-model="candidateLimit"
								type="text"
								name="candidateLimit"
								aria-label="최대 참여 가능 인원"
								placeholder="최대 참여 가능 인원"
							/>
						</RegisterRow>

						<RegisterRow title="클라이언트">
							<p class="event-line">
								<RadioList
									v-model="clientType"
									:radioList="clientTypeList"
								/>
							</p>
							<p class="event-line">
								<label v-show="clientType === 1">
									<input
										v-model="clientNameCustom"
										class="event-input--medium"
										type="text"
									/>
								</label>
							</p>
							<SearchBrand
								ref="searchBrand"
								v-show="clientType === 2"
								:show-if-is-display="true"
								@change="
									setEventValueToTarget($event, 'clientBrand')
								"
							/>
						</RegisterRow>
						<RegisterRow title="제품 정보">
							<table class="inner-table">
								<tr>
									<th>브랜드</th>
									<td>
										<input
											type="text"
											v-model="brandInfo"
										/>
									</td>
								</tr>
								<tr>
									<th>제공 제품</th>
									<td>
										<input
											type="text"
											v-model="productInfo"
										/>
									</td>
								</tr>
							</table>
						</RegisterRow>
					</RegisterTable>
					<RegisterTable title="댓글 기능">
						<template slot="buttons">
							<button
								v-if="mode === 'modify' && isReply === 1"
								@click="openReplyList"
								type="button"
								class="button"
							>
								댓글 리스트
							</button>
						</template>
						<template>
							<RegisterRow title="댓글 기능">
								<RadioList
									v-model="isReply"
									:radioList="isReplyList"
									:disabled="true"
									:disabled-ids="[
										prerequisiteType === 3 ? 0 : '',
									]"
								/>
							</RegisterRow>

							<RegisterRow
								v-show="isReply === 1"
								title="플레이스홀더"
							>
								<text-counter
									v-model="replyHolderText"
									:max-length="150"
									:use-textarea="true"
									:rows="4"
									:use-line-limit="true"
								/>
							</RegisterRow>
						</template>
					</RegisterTable>
					<RegisterTable title="이벤트 참여 정보">
						<RegisterRow title="이벤트 구분">
							<RadioList
								v-model="eventType"
								:radioList="eventTypeList"
								:disabled="true"
								:disabled-ids="[3]"
							/>
						</RegisterRow>
						<RegisterRow
							v-if="eventType === 2"
							title="평가단 활동 기간"
						>
							<p class="event__warn" v-if="!eventPeriod.to">
								이벤트 종료 날짜를 먼저 설정해 주세요
							</p>
							<div v-else>
								<span class="event__terms-label"
									>이벤트 종료일로부터</span
								>
								<label>
									<select
										class="event__term-preset"
										v-model="termPreset"
										@change="setTerms"
										:disabled="!eventPeriod.to"
									>
										<option value="3_M">3개월</option>
										<option value="6_M">6개월</option>
										<option value="1_y">1년</option>
										<option value="direct">
											직접 입력
										</option>
									</select>
								</label>
								<label v-show="termPreset === 'direct'">
									<input
										v-model="terms"
										@input="setTerms"
										class="event-input--small"
										type="text"
										:disabled="!eventPeriod.to"
									/>
									<span>일</span>
								</label>
								<span class="event__activity-end-date">
									{{ getActivityDate }}
								</span>
							</div>
						</RegisterRow>
						<RegisterRow
							v-if="eventType !== 3"
							:title="getSearchProductTitle"
						>
							<ProductSearcher2
								v-if="products.length < productsMaxLength"
								@change="addProduct"
							/>
							<table
								v-if="products.length > 0"
								class="inner-table event__productions"
							>
								<tr>
									<th style="width: 100px">제품항번</th>
									<th style="width: 100px">브랜드명</th>
									<th style="width: 100px">제품명</th>
									<th style="width: 100px">이미지</th>
									<th style="width: 50px">노출</th>
									<th style="width: 50px">단종</th>
									<th style="width: 50px">삭제</th>
								</tr>
								<tr
									v-for="(product, idx) in products"
									:key="product.idProduct"
								>
									<td>{{ product.idProduct }}</td>
									<td>{{ product.brandTitle }}</td>
									<td>{{ product.productTitle }}</td>
									<td>
										<img
											class="event__productions__image"
											:src="product.filePath"
											:alt="`${product.brandTitle} 제품 이미지`"
											@click="
												showImageModal(product.filePath)
											"
										/>
									</td>
									<td>
										{{
											product.isDisplay
												? '노출'
												: '비노출'
										}}
									</td>
									<td>
										{{
											product.isDiscontinue
												? '단종'
												: '미단종'
										}}
									</td>
									<td>
										<button
											@click="removeProduct(idx)"
											type="button"
											class="event__remove-product"
										>
											<i class="fa fas fa-minus"></i>
										</button>
									</td>
								</tr>
							</table>
						</RegisterRow>

						<RegisterRow
							v-if="eventType === 2 || eventType === 6"
							title="리뷰유도창 노출기간"
						>
							<DateRange
								v-model="alertNoReviewPeriod"
								type="date"
							/>
						</RegisterRow>
						<RegisterRow v-if="eventType === 6" title="미션 안내">
							<table class="inner-table">
								<tr
									v-for="(field, index) in fields"
									:key="index"
								>
									<th>{{ field.label }}</th>
									<td>
										<input
											v-model="mission[field.model]"
											type="text"
											:placeholder="`${field.label}을(를) 입력해주세요.`"
										/>
									</td>
								</tr>
							</table>
						</RegisterRow>

						<RegisterRow title="참여조건">
							<RadioList
								v-model="prerequisiteType"
								:radioList="prerequisiteTypeList"
								:disabled="true"
								:disabled-ids="[2, isReply === 0 ? 3 : '']"
							/>
							<table
								v-show="prerequisiteType === 1"
								class="inner-table"
							>
								<tr>
									<th>리뷰 작성 기간</th>
									<td>
										<p class="event-line">
											<RadioList
												:value="isAllDate"
												:radioList="isAllDateList"
												@input="handleIsAllDateChange"
											/>
										</p>
										<p
											v-show="isAllDate === 0"
											class="event-line"
										>
											<DateRange
												v-model="prerequisiteDate"
											/>
										</p>
									</td>
								</tr>
								<tr>
									<th>대상 카테고리</th>
									<td>
										<p class="event-line">
											<RadioList
												v-model="categoryTarget"
												:radioList="categoryTargetList"
											/>
										</p>
										<CategorySelector
											v-show="categoryTarget === 0"
											ref="categorySelector"
											:disabled="!isNewCategory"
											@change="
												setEventValueToTarget(
													$event,
													'targetCategories'
												)
											"
										/>
									</td>
								</tr>
								<tr>
									<th>리뷰 개수</th>
									<td>
										<label>
											<input
												v-model="prerequisiteLimit"
												class="event-input--small"
												type="text"
											/>
										</label>
										개 이상 작성
									</td>
								</tr>
							</table>

							<table
								v-show="prerequisiteType === 2"
								class="inner-table"
							>
								<tr>
									<th>상품 구매 기간</th>
									<td>
										<p class="event-line">
											<RadioList
												v-model="isAllDateForPurchase"
												:radioList="isAllPurchaseList"
											/>
										</p>
										<p
											v-show="isAllDateForPurchase === 0"
											class="event-line"
										>
											<DateRange v-model="purchaseDate" />
										</p>
									</td>
								</tr>
								<tr>
									<th>구매 금액</th>
									<td>
										<label>
											<input
												v-model="purchasePrice"
												class="event-input--small"
												type="text"
											/>
										</label>
										원 이상 구매
									</td>
								</tr>
							</table>
							<table
								v-show="prerequisiteType === 6"
								class="inner-table"
							>
								<tr>
									<th>대상</th>
									<td class="event__grade">
										<div class="event__grade-select">
											<RadioList
												v-model="reviewerGrade"
												:radioList="reviewerGradeList"
											/>
										</div>
										<CategorySelector
											v-show="reviewerGrade === 2"
											ref="brandCategorySelector"
											category-depth="secondary"
											@change="
												setEventValueToTarget(
													$event,
													'gradeTargetCategories'
												)
											"
										/>
										<BrandSelectors
											ref="brandSelector"
											v-show="reviewerGrade === 4"
											@enter="$emit('enter')"
											@change="
												selectedBrandTarget(
													$event,
													'gradeBrandList'
												)
											"
										/>
									</td>
								</tr>
								<tr>
									<th>등급</th>
									<td class="event__grade">
										<div class="event__grade-select">
											<RadioList
												v-model="gradeList"
												:radioList="gradeListType"
											/>
										</div>
									</td>
								</tr>
							</table>
							<table
								v-show="prerequisiteType === 7"
								class="inner-table"
							>
								<tr>
									<th>가입 기간 설정</th>
									<td>
										<p class="event-line">
											<DateRange v-model="joinDate" />
										</p>
									</td>
								</tr>
							</table>
						</RegisterRow>
						<RegisterRow title="하단 버튼">
							<table class="inner-table">
								<tr>
									<th>하단 버튼 문구</th>
									<td>
										<label>
											<select
												v-model="btnLinkTextOption"
												@change="setBtnLinkText"
											>
												<option value="이벤트 신청하기">
													이벤트 신청하기
												</option>
												<option value="평가단 신청하기">
													평가단 신청하기
												</option>
												<option value="기획전 보러가기">
													기획전 보러가기
												</option>
												<option value="샘플링 신청하기">
													샘플링 신청하기
												</option>
												<option value="설문단 신청하기">
													설문단 신청하기
												</option>
												<option value="direct">
													직접입력
												</option>
											</select>
										</label>
										<label
											v-if="
												btnLinkTextOption === 'direct'
											"
										>
											<input
												v-model="btnLinkText"
												maxlength="10"
												placeholder="최대 10자"
												class="event-input--small"
												type="text"
											/>
											({{ btnLinkText.length }} / 10)
										</label>
									</td>
								</tr>
								<tr v-show="prerequisiteType === 5">
									<th>링크 종류</th>
									<td>
										<label>
											<select v-model="linkType">
												<option
													v-for="item in linkTypeList"
													:value="item.id"
													:key="item.id"
												>
													{{ item.name }}
												</option>
											</select>
										</label>
									</td>
								</tr>
								<tr v-show="prerequisiteType === 5">
									<th>링크 값</th>
									<td>
										<label>
											<input
												v-model="linkValue"
												type="text"
											/>
										</label>
									</td>
								</tr>
							</table>
						</RegisterRow>
					</RegisterTable>

					<RegisterTable
						v-show="prerequisiteType !== 5"
						title="이벤트 신청 정보"
					>
						<RegisterRow title="신청방법">
							<p class="event-line">
								<CheckboxList
									:checkboxList="applicationList"
									v-model="applicationInfo"
									:disabledIds="disabledCheckboxIds"
								/>
							</p>
							<ApplyOptionSelector
								ref="optionSelector"
								@change="
									setEventValueToTarget(
										$event,
										'applyOptions'
									)
								"
								v-show="selectCheckbox('1')"
								class="event__apply"
								:isApply="isApply"
							/>

							<ApplyInputText
								ref="inputText"
								@change="
									setEventValueToTarget(
										$event,
										'applyInputText'
									)
								"
								v-show="selectCheckbox('2')"
								class="event__apply"
								:isApply="isApply"
							/>

							<ApplyImageUpload
								ref="imageUpload"
								@change="
									setEventValueToTarget(
										$event,
										'applyImageUpload'
									)
								"
								v-show="selectCheckbox('3')"
								class="event__apply"
							/>

							<table
								class="inner-table event__apply"
								v-show="selectCheckbox('4')"
							>
								<tr>
									<th>타이틀</th>
									<td>
										<label>
											<input
												placeholder="표시될 타이틀을 입력해주세요."
												v-model="applySingleTitle"
												type="text"
											/>
										</label>
									</td>
								</tr>
								<tr>
									<th>내용</th>
									<td>
										<label>
											<input
												placeholder="표시될 내용을 입력해주세요."
												v-model="applySingleContext"
												type="text"
											/>
										</label>
									</td>
								</tr>
							</table>
						</RegisterRow>
					</RegisterTable>
				</td>
				<td>
					<RegisterTable title="이미지 정보">
						<RegisterRow
							title="리스트 배너<br><span style='color:#ff3860;font-weight:bold'>(1029*432)</span>"
						>
							<ImageUploader
								group="event"
								:image-src="bannerImagePath"
								:image-size-limit="{
									width: 1029,
									height: 432,
									previewWidth: 400,
									type: 'fit',
								}"
								@upload="onImageUpload"
							/>
						</RegisterRow>
						<RegisterRow title="이벤트 내용">
							<TextEditor
								v-model="eventContext"
								:height="772"
								:api-key="textEditorApiKey"
							/>
						</RegisterRow>
					</RegisterTable>
					<RegisterTable
						v-if="prerequisiteType !== 5"
						title="제3자 정보제공 동의"
					>
						<RegisterRow title="제공받는 업체">
							<label>
								<input
									v-model="thirdAgreeCompany"
									type="text"
								/>
							</label>
						</RegisterRow>
						<RegisterRow title="제공목적">
							<label>
								<input
									v-model="thirdAgreePurpose"
									type="text"
								/>
							</label>
						</RegisterRow>
						<RegisterRow title="제공정보">
							<label>
								<input v-model="thirdAgreeInfo" type="text" />
							</label>
						</RegisterRow>
						<RegisterRow title="보유 및 이용기간">
							<label>
								<input v-model="thirdAgreeDate" type="text" />
							</label>
						</RegisterRow>
					</RegisterTable>
				</td>
			</tr>
		</table>
		<div class="event__button-wrapper">
			<button type="submit" class="btn" v-text="getButtonName" />
			<a
				v-if="mode === 'modify' && prerequisiteType !== 5"
				:href="`/events/${idEvent}/winner-pick`"
			>
				<button type="button" class="btn btn-winner">
					당첨자 선정하기
				</button>
			</a>
		</div>
	</form>
</template>
<script>
	import { mapState } from 'vuex';
	import { imageRemove, getIdRegister, getRegexp } from '@/util';
	import DateRange from '@/components/DateRange';
	import RegisterTable from '@/components/event/RegisterTable';
	import RegisterRow from '@/components/event/RegisterRow';
	import CategorySelector from '@/components/event/CategorySelector';
	import ApplyOptionSelector from '@/components/event/ApplyOptionSelector';
	import ApplyInputText from '@/components/event/ApplyInputText';
	import ApplyImageUpload from '@/components/event/ApplyImageUpload';
	import SearchBrand from '@/components/SearchBrand';
	import BrandSelectors from '@/components/event/BrandSelectors';
	import TextEditor from '@/components/TextEditor';
	import ImageUploader from '@/components/ImageUploader';
	import moment from 'moment';
	import { isEqual, uniqWith, each, cloneDeep } from 'lodash';
	import TextCounter from '@/components/TextCounter';
	import ProductSearcher2 from '@/components/ProductSearcher2';
	import DateBox from '@/components/DateBox';
	import RadioList from '@/components/RadioList.vue';
	import CheckboxList from '@/components/CheckboxList';

	export default {
		name: 'Event',
		components: {
			DateRange,
			RegisterTable,
			RegisterRow,
			CategorySelector,
			ApplyOptionSelector,
			ApplyInputText,
			ApplyImageUpload,
			TextEditor,
			ImageUploader,
			SearchBrand,
			TextCounter,
			ProductSearcher2,
			DateBox,
			BrandSelectors,
			RadioList,
			CheckboxList,
		},
		props: {
			mode: {
				type: String,
				default: 'register',
			},
		},
		data() {
			return {
				isShowImageModal: false,
				imageModalSrc: null,
				isHidden: 1,
				isHiddenList: [
					{ id: 1, value: '일반' },
					{ id: 0, value: '히든' },
				],
				idEvent: null,
				isDisplay: 1,
				isDisplayList: [
					{ id: 1, value: '노출' },
					{ id: 0, value: '비노출' },
				],
				eventTitle: '',
				eventDesc: '',
				eventPeriod: { from: '', to: '' },
				eventProductList: [],
				winnerIssueOn: '',
				reviewEndAt: '',
				winnerLimit: null,
				eventType: 1,
				eventTypeList: [
					{ id: 1, value: '글픽존' },
					{ id: 2, value: '평가단' },
					{ id: 3, value: '스토어' },
					{ id: 4, value: '샘플링' },
					{ id: 5, value: '설문단' },
					{ id: 6, value: 'SNS' },
				],
				clientType: 1,
				clientTypeList: [
					{ id: 1, value: '자체진행' },
					{ id: 2, value: '브랜드' },
				],
				clientBrandList: [],
				clientNameCustom: '',
				clientBrand: {
					brandTitle: '',
					idBrand: null,
				},
				showSearchBrand: false,
				isReply: 0,
				isReplyList: [
					{ id: 1, value: '사용함' },
					{ id: 0, value: '사용안함' },
				],
				replyHolderText: '',
				termPreset: '6_M',
				terms: 0,
				activityDate: null,
				prerequisiteType: 1,
				prerequisiteTypeList: [
					{ id: 1, value: '리뷰' },
					{ id: 2, value: '구매' },
					{ id: 3, value: '댓글' },
					{ id: 4, value: '모두 참여 가능' },
					{ id: 5, value: '참여형 아님' },
					{ id: 6, value: '리뷰어 등급' },
					{ id: 7, value: '가입기간' },
					{ id: 8, value: '픽플' },
				],
				isAllDate: 1,
				isAllDateList: [
					{ id: 1, value: '전체 기간' },
					{ id: 0, value: '기간 설정' },
				],
				prerequisiteDate: { from: '', to: '' },
				prerequisiteLimit: 0,
				products: [],
				categoryTarget: 1,
				categoryTargetList: [
					{ id: 1, value: '모든 카테고리' },
					{ id: 0, value: '카테고리 지정' },
				],
				isAllDateForPurchase: 1,
				isAllPurchaseList: [
					{ id: 1, value: '전체 기간' },
					{ id: 0, value: '기간 설정' },
				],
				purchaseDate: { from: '', to: '' },
				purchasePrice: 0,
				joinDate: { from: '', to: '' },
				reviewerGrade: 0,
				reviewerGradeList: [
					{ id: 0, value: '전체' },
					{ id: 1, value: '카테고리 전체' },
					{ id: 2, value: '카테고리 설정' },
					{ id: 3, value: '브랜드 전체' },
					{ id: 4, value: '브랜드 설정' },
				],
				btnLinkTextOption: '이벤트 신청하기',
				btnLinkText: '이벤트 신청하기',
				linkType: '44',
				linkValue: '0',
				targetCategories: [],
				gradeTargetCategories: [],
				reviewCategory: [],
				gradeCategory: [],
				applicationInfo: [],
				applicationList: [
					{ id: '1', value: '옵션 선택' },
					{ id: '2', value: '텍스트 입력' },
					{ id: '3', value: '이미지 업로드' },
					{ id: '4', value: '단일형' },
				],
				applyOptions: [],
				applyInputText: [],
				applyImageUpload: [],
				applySingleTitle: '',
				applySingleContext: '',
				eventContext: '',
				imageDto: {},
				bannerImagePath: null,
				prevImagePath: null,
				showPreviewImage: false,
				isNewCategory: true,
				thirdAgreeCompany: '',
				thirdAgreePurpose: '이벤트 상품 배송',
				thirdAgreeInfo:
					'닉네임, 연령, 성별, 피부타입, 이름, 주소, 휴대폰 번호',
				thirdAgreeDate: '서비스 제공 완료 후 30일',
				alertNoReviewPeriod: { from: '', to: '' },
				gradeList: 5,
				gradeListType: [
					{ id: 5, value: 'Lv5 마스터' },
					{ id: 4, value: 'Lv4 엑스퍼트' },
					{ id: 3, value: 'Lv3 콜렉터' },
					{ id: 2, value: 'Lv2 익스플로러' },
					{ id: 1, value: 'Lv1 비기너' },
				],
				prerequisiteTarget: 'ALL',
				eventCategories: [],
				gradeBrandList: [],
				eventQuestionList: [],
				submitApplyType: [],
				isApply: false,
				productsMaxLength: 30,
				candidateLimit: null,
				mission: {
					mission1: '사진 최소 3장 필수 (제형 or 사용 컷)',
					mission2: '사용 텍스트 리뷰 필수',
					mission3: '게시글 유지 기간 : 게시일로부터 3개월',
					hashTag: '#광고 #글로우픽체험단 #글로리그램',
					accountTag: '@glowpick_official',
				},
				fields: [
					{ label: '안내1', model: 'mission1' },
					{ label: '안내2', model: 'mission2' },
					{ label: '안내3', model: 'mission3' },
					{ label: '해시태그', model: 'hashTag' },
					{ label: '계정태그', model: 'accountTag' },
				],
				missionDoc: '',
				brandInfo: '',
				productInfo: '',
			};
		},
		mounted() {
			if (this.mode === 'modify') {
				this.$axiosAdmin2
					.get(`/api/events/${this.$route.params.idEvent}`)
					.then(({ data }) => {
						this.setModifyData(data.data);
					})
					.catch(err => {
						console.error(err);
						alert(
							'데이터를 가져오는 중 에러가 발생했습니다.\n문제가 지속될 시 관리자에게 문의해 주세요.'
						);
					});
			}
			this.$store.commit('toggleSpinner', false);
		},
		watch: {
			prerequisiteType(value) {
				if (value !== 5) {
					this.linkType = '44';
					this.linkValue = '0';
				}
				if (value === 5) {
					this.setBtnLink();
				}
			},
			eventType(value) {
				if (value === 2) {
					this.setTerms();
				}
			},
		},
		computed: {
			...mapState({
				linkTypeList: state => state.filter.newLinkTypeList,
				reviewer_grade_list: state => state.filter.reviewer_grade_list,
			}),
			getActivityDate() {
				return `(활동 종료일 ${moment(this.activityDate * 1000).format('YYYY년 MM월 DD일')})`;
			},
			getButtonName() {
				if (this.mode === 'modify') {
					return '이벤트 수정하기';
				} else {
					return '이벤트 등록하기';
				}
			},
			getSearchProductTitle() {
				switch (this.eventType) {
					case 1:
						return '글픽존 제품';
					case 2:
						return '평가단 제품';
					case 4:
						return '샘플링 제품';
					case 5:
						return '설문단 제품';
					case 6:
						return 'SNS 제품';
					default:
						return '';
				}
			},
			getDescLength() {
				return !this.eventDesc ? 0 : this.eventDesc.length;
			},
			checkApplyLength() {
				return this.applicationInfo.length;
			},
			disabledCheckboxIds() {
				return this.checkApplyLength >= 2
					? this.applicationList
							.map(item => String(item.id))
							.filter(
								item => !this.applicationInfo.includes(item)
							)
					: [];
			},
			textEditorApiKey() {
				const { NODE_ENV, TINYMCE_API_KEY } = this.$store.state.env;
				return NODE_ENV === 'production'
					? Math.floor(Math.random() * 2)
						? 'sj93vrmsiz0n0v4f13za4p69ic8wbanco4598c2r2txzdu4b'
						: '8sjiltneueju3kv6rm87zxh2s9wc1aetheqahgs7tco50r1v'
					: TINYMCE_API_KEY;
			},
		},
		methods: {
			showImageModal(src) {
				this.imageModalSrc = src;
				this.isShowImageModal = true;
			},
			hideImageModal() {
				this.imageModalSrc = null;
				this.isShowImageModal = false;
			},
			selectCheckbox(value) {
				return this.applicationInfo.includes(value);
			},
			setModifyData(data) {
				this.idEvent = data.idEvent;
				this.isDisplay = data.isDisplay ? 1 : 0;
				this.isHidden = data.isHidden ? 0 : 1;
				this.eventTitle = data.eventTitle;
				this.eventProductList = data.eventProductList;
				this.eventDesc = data.eventDesc;
				this.isNewCategory = data.isNewCategory;
				this.eventPeriod = {
					from: data.startDate
						? moment.unix(data.startDate).format('YYYY-MM-DDTHH:mm')
						: '',
					to: data.endDate
						? moment.unix(data.endDate).format('YYYY-MM-DDTHH:mm')
						: '',
				};
				this.winnerIssueOn = data.winnerIssueOn
					? moment(data.winnerIssueOn, 'X').format('YYYY-MM-DD')
					: '';
				this.reviewEndAt = data.reviewEndAt
					? moment(data.reviewEndAt, 'x').format('YYYY-MM-DD')
					: '';
				this.winnerLimit = data.winnerLimit;
				this.clientType = data.clientType;
				if (this.clientType === 2) {
					this.clientBrand.brandTitle = data.clientName;
					this.clientBrand.idBrand = data.idBrand;
					this.$refs.searchBrand.setBrand(
						this.clientBrand.idBrand,
						this.clientBrand.brandTitle
					);
				} else {
					this.clientNameCustom = data.clientName;
				}
				this.isReply = data.isReply ? 1 : 0;
				this.replyHolderText = data.replyHolderText;
				this.prerequisiteTarget = data.prerequisiteTarget;
				this.eventType = data.eventType;
				this.activityDate = data.activityDate;
				this.candidateLimit = data.candidateLimit;
				this.brandInfo = data.brandInfo;
				this.productInfo = data.productInfo;

				if (this.eventType === 2) {
					this.termPreset = 'direct';
					this.terms =
						(this.activityDate -
							moment(
								this.eventPeriod.to,
								'YYYY-MM-DDTHH:mm'
							).format('X')) /
						60 /
						60 /
						24;
				}

				this.prerequisiteType = data.prerequisiteType;
				const prerequisiteStartDate =
					data.prerequisiteStartDate === 0
						? ''
						: moment
								.unix(data.prerequisiteStartDate)
								.format('YYYY-MM-DDTHH:mm');
				const prerequisiteEndDate =
					data.prerequisiteEndDate === 0
						? ''
						: moment
								.unix(data.prerequisiteEndDate)
								.format('YYYY-MM-DDTHH:mm');

				if (this.prerequisiteType === 1) {
					this.isAllDate = data.isAllDate ? 1 : 0;
					this.prerequisiteDate = {
						from: prerequisiteStartDate,
						to: prerequisiteEndDate,
					};
					this.prerequisiteLimit = data.prerequisiteLimit;
					this.purchasePrice = 0;
					this.categoryTarget =
						data.prerequisiteTarget === 'ALL' ? 1 : 0;
				}

				if (this.prerequisiteType === 2) {
					this.isAllDateForPurchase = data.isAllDate ? 1 : 0;
					this.purchaseDate = {
						from: prerequisiteStartDate,
						to: prerequisiteEndDate,
					};
					this.prerequisiteLimit = 0;
					this.purchasePrice = data.prerequisiteLimit;
				}

				if (this.prerequisiteType === 6) {
					this.prerequisiteLimit = data.prerequisiteLimit;
					switch (this.prerequisiteTarget) {
						case 'ALL':
							this.reviewerGrade = 0;
							break;
						case 'CATEGORY_ALL':
							this.reviewerGrade = 1;
							break;
						case 'CATEGORY_TARGET':
							this.reviewerGrade = 2;
							break;
						case 'BRAND_ALL':
							this.reviewerGrade = 3;
							break;
						case 'BRAND_TARGET':
							this.reviewerGrade = 4;
							break;
						default:
							break;
					}
					switch (this.prerequisiteLimit) {
						case 51:
							this.gradeList = 5;
							break;
						case 21:
							this.gradeList = 4;
							break;
						case 11:
							this.gradeList = 3;
							break;
						case 6:
							this.gradeList = 2;
							break;
						case 1:
							this.gradeList = 1;
							break;
						default:
							break;
					}
				}

				if (this.prerequisiteType === 7) {
					this.joinDate = {
						from: prerequisiteStartDate,
						to: prerequisiteEndDate,
					};
				}

				if (this.prerequisiteTarget === 'CATEGORY_TARGET') {
					if (this.prerequisiteType === 1) {
						this.$refs.categorySelector.setList(data.categories);
					}

					if (
						this.prerequisiteType === 6 &&
						this.reviewerGrade === 2
					) {
						this.$refs.brandCategorySelector.setList(
							data.categories
						);
					}
				}

				if (this.prerequisiteTarget === 'BRAND_TARGET') {
					if (
						this.prerequisiteType === 6 &&
						this.reviewerGrade === 4
					) {
						this.$refs.brandSelector.setList(data.brands);
						this.gradeBrandList = data.brands;
						const brandList = cloneDeep(this.gradeBrandList);
						brandList.forEach(item => {
							item.brandId = item.idBrand;
							delete item.showSearchBrand;
							delete item.brandTitle;
							delete item.idBrand;
						});
						this.gradeBrandList = brandList;
					}
				}

				const btnOptions = [
					'이벤트 신청하기',
					'평가단 신청하기',
					'기획전 보러가기',
					'샘플링 신청하기',
					'설문단 신청하기',
				];

				if (btnOptions.indexOf(data.btnLinkText) > -1) {
					this.btnLinkTextOption = data.btnLinkText;
				} else {
					this.btnLinkTextOption = 'direct';
				}

				this.btnLinkText = data.btnLinkText;
				this.linkValue = data.linkValue;
				this.linkType = data.linkType || '44';
				this.isApply = data.isApply;

				this.eventQuestionList = data.eventQuestionList;

				this.eventQuestionList.forEach(item => {
					const applyType = item.applyType.toString();
					const options = JSON.parse(item.options);

					this.applicationInfo.push(applyType);

					switch (applyType) {
						default:
						case '1':
							this.$refs.optionSelector.setSelector(options);
							break;
						case '2':
							this.$refs.inputText.setTexts(options);
							break;
						case '3':
							this.$refs.imageUpload.setImageUpload(options);
							break;
						case '4':
							this.applySingleTitle = options[0].title;
							this.applySingleContext = options[0].option[0].item;
							break;
					}
				});

				this.eventContext = data.eventContent.eventText;
				this.bannerImagePath = data.eventContent.filePath;
				this.prevImagePath = data.eventContent.filePath;
				this.thirdAgreeCompany = data.thirdAgreeCompany;
				this.thirdAgreeDate = data.thirdAgreeDate;
				this.thirdAgreeInfo = data.thirdAgreeInfo;
				this.thirdAgreePurpose = data.thirdAgreePurpose;
				this.products = data.products;
				if (data.alertNoReviewStartOn && data.alertNoReviewEndOn) {
					this.alertNoReviewPeriod.from = moment(
						data.alertNoReviewStartOn
					)
						.utcOffset('9')
						.format('YYYY-MM-DD');
					this.alertNoReviewPeriod.to = moment(
						data.alertNoReviewEndOn
					)
						.utcOffset('9')
						.format('YYYY-MM-DD');
				}
				this.missionDoc = data.missionDoc;

				if (this.missionDoc?.length > 0) {
					const parsedData = JSON.parse(this.missionDoc);
					this.mission = {};
					parsedData.contentList?.forEach(item => {
						if (item.type === 'info') {
							this.mission[`mission${item.order}`] = item.text;
						} else if (item.type === 'hash_tag') {
							this.mission.hashTag = item.text;
						} else if (item.type === 'account_tag') {
							this.mission.accountTag = item.text;
						}
					});
				}
			},
			openReplyList() {
				// 모달을 열기전 id 넣어주기
				this.$store.commit('EventCommentList/idEvent', this.idEvent);

				// 모달 열기
				this.$store.commit('modal/toggleModal', {
					id: 'EventCommentList',
					modalTitle: this.eventTitle,
				});
			},
			onInputEventPeriod({ to }) {
				if (to) {
					this.setTerms();
				}
			},
			setTerms() {
				if (this.termPreset === 'direct') {
					this.activityDate = moment(
						this.eventPeriod.to,
						'YYYY-MM-DDTHH:mm'
					)
						.add(this.terms, 'd')
						.format('X');
				} else {
					const [value, unit] = this.termPreset.split('_');
					this.activityDate = moment(
						this.eventPeriod.to,
						'YYYY-MM-DDTHH:mm'
					)
						.add(value, unit)
						.format('X');
				}
			},
			setBtnLink() {
				if (this.prerequisiteType !== 5) {
					this.linkType = 'outlink';
					this.linkValue = '';
				}
			},
			setBtnLinkText(event) {
				const value = event.target.value;

				if (value === 'direct') {
					this.btnLinkText = '';
				} else {
					this.btnLinkText = value;
				}
			},
			setEventValueToTarget(event, target) {
				this[target] = event;
			},

			// 신청정보 등록 DATA
			getApplyInfo() {
				const applyInfo = [];

				this.applicationInfo.forEach((item, index) => {
					switch (item) {
						case '1':
							applyInfo.push({
								...this.eventQuestionList[index],
								applyType: Number(item),
								options: JSON.stringify(this.applyOptions),
							});
							break;
						case '2':
							applyInfo.push({
								...this.eventQuestionList[index],
								applyType: Number(item),
								options: JSON.stringify(this.applyInputText),
							});
							break;
						case '3':
							applyInfo.push({
								...this.eventQuestionList[index],
								applyType: Number(item),
								options: JSON.stringify(this.applyImageUpload),
							});
							break;
						case '4':
							applyInfo.push({
								...this.eventQuestionList[index],
								applyType: Number(item),
								options: JSON.stringify([
									{
										title: this.applySingleTitle,
										option: [
											{ item: this.applySingleContext },
										],
									},
								]),
							});
							break;
						default:
							break;
					}
				});
				return applyInfo;
			},
			addProduct(item) {
				const maxLength = this.productsMaxLength;
				if (this.products.length < maxLength) {
					this.products.push({
						brandTitle: item.brandTitle,
						filePath: item.filePath,
						idProduct: item.idProduct,
						isDiscontinue: item.isDiscontinue,
						isDisplay: item.isDisplay,
						productTitle: item.productTitle,
					});
				} else {
					alert(`제품은 ${maxLength}개까지 등록 가능합니다.`);
				}
			},
			removeProduct(index) {
				const findIdx = this.eventProductList.findIndex(
					item => item.idProduct === this.products[index].idProduct
				);
				if (this.eventProductList[findIdx]?.hasProductWinner) {
					alert('해당 제품의 당첨자를 모두 제외 후 삭제해주세요');
					return;
				}
				this.products.splice(index, 1);
			},
			onImageUpload(event) {
				const imageHost = `${this.$store.state.env.IMAGE_STORAGE_PATH}`;

				if (event.fileDir) {
					this.bannerImagePath = `${imageHost}${event.fileDir}/${event.fileSaveName}`;
					this.imageDto = event;
				} else {
					this.bannerImagePath = '';
					this.imageDto = {};
				}
			},
			validate(target, message) {
				if (!target || target.length === 0) {
					alert(message);
					return false;
				}

				return true;
			},
			checkValidDate(start, end, message) {
				if (!start || !end) return true;
				const startDate = moment(start).valueOf();
				const endDate = moment(end).valueOf();
				if (endDate < startDate) {
					alert(message);
					return false;
				}
				return true;
			},
			validations() {
				if (
					!this.validate(this.eventTitle, '이벤트명을 입력해주세요')
				) {
					return false;
				}

				if (
					!this.validate(
						this.eventDesc,
						'이벤트 부가설명을 입력해주세요'
					)
				) {
					return false;
				}

				if (
					!this.validate(
						this.eventPeriod.from,
						'이벤트 기간을 입력해주세요'
					)
				) {
					return false;
				}

				if (
					!this.validate(
						this.eventPeriod.to,
						'이벤트 기간을 입력해주세요'
					)
				) {
					return false;
				}

				if (
					!this.checkValidDate(
						this.eventPeriod.from,
						this.eventPeriod.to,
						'이벤트 종료일이 이벤트 시작일보다 이전입니다'
					)
				) {
					return false;
				}

				const eventEndDate = moment(this.eventPeriod.to).format(
					'YYYY-MM-DD'
				);
				const winningDate = moment(this.winnerIssueOn).format(
					'YYYY-MM-DD'
				);
				if (
					eventEndDate !== winningDate &&
					!this.checkValidDate(
						this.eventPeriod.to,
						this.winnerIssueOn,
						'당첨자 발표일이 이벤트 종료일보다 이전입니다'
					)
				) {
					return false;
				}

				if (this.winnerLimit) {
					const winnerLimit = Number(this.winnerLimit);

					if (isNaN(winnerLimit) || winnerLimit < 1) {
						alert('당첨인원은 0보다 큰 숫자를 입력해주세요');
						return false;
					}
				}

				if (this.candidateLimit) {
					const candidateLimit = Number(this.candidateLimit);
					const winnerLimit = Number(this.winnerLimit);

					if (isNaN(candidateLimit) || candidateLimit < 1) {
						alert(
							'최대 참여 가능 인원은 0보다 큰 숫자를 입력해주세요'
						);
						return false;
					}

					if (winnerLimit && candidateLimit > winnerLimit) {
						alert(
							'최대 참여 가능 인원은 당첨인원 보다 클 수 없습니다.'
						);
						return false;
					}
				}

				if (this.isReply === 1) {
					if (
						!this.validate(
							this.replyHolderText,
							'댓글 플레이스홀더를 입력해주세요'
						)
					) {
						return false;
					}
				}

				if (this.clientType === 2) {
					if (
						!this.validate(
							this.clientBrand.brandTitle,
							'클라이언트를 입력해 주세요'
						)
					) {
						return false;
					}

					if (
						!this.validate(
							this.clientBrand.idBrand,
							'클라이언트를 입력해 주세요'
						)
					) {
						return false;
					}
				} else {
					if (
						!this.validate(
							this.clientNameCustom,
							'자체진행 클라이언트 명을 입력해주세요'
						)
					) {
						return false;
					}
				}

				if (!this.brandInfo && this.productInfo?.length > 0) {
					alert('제품정보 브랜드를 입력해주세요');
					return false;
				}

				if (!this.productInfo && this.brandInfo?.length > 0) {
					alert('제품정보 제공제품을 입력해주세요');
					return false;
				}

				if (this.eventType === 2) {
					if (
						!this.validate(
							this.activityDate,
							'평가단 활동기간을 입력해주세요'
						)
					) {
						return false;
					}

					if (this.termPreset === 'direct' && this.terms <= 0) {
						alert('평가단 활동기간은 최소 1일 이상을 지정해주세요');
						return false;
					}
				}

				if (this.eventType !== 1 && this.eventType !== 3) {
					let productErrorText;

					if (this.eventType === 2) {
						productErrorText = '평가단';
					} else if (this.eventType === 4) {
						productErrorText = '샘플링';
					} else if (this.eventType === 5) {
						productErrorText = '설문단';
					}

					if (
						!this.validate(
							this.products,
							`${productErrorText} 제품을 선택해주세요`
						)
					) {
						return false;
					}
				}

				if (
					!this.checkValidDate(
						this.alertNoReviewPeriod.from,
						this.alertNoReviewPeriod.to,
						'리뷰 유도창 노출기간 종료일이 시작일보다 이전날짜입니다'
					)
				) {
					return false;
				}

				if (
					!this.checkValidDate(
						this.winnerIssueOn,
						this.alertNoReviewPeriod.from,
						'리뷰유도창 노출기간 시작일이 당첨자 발표일보다 이전날짜입니다.'
					)
				) {
					return false;
				}

				if (this.prerequisiteType === 1 && this.isAllDate === 0) {
					if (isNaN(this.prerequisiteLimit)) {
						alert('올바른 참여 조건을 입력해 주세요');
						return false;
					}
				} else if (this.prerequisiteType === 2) {
					this.prerequisiteLimit = this.purchasePrice;

					if (isNaN(this.prerequisiteLimit)) {
						alert('올바른 참여 조건을 입력해 주세요');
						return false;
					}
				}

				if (
					!this.checkValidDate(
						this.prerequisiteDate.from,
						this.prerequisiteDate.to,
						'리뷰 작성기간 종료일이 시작일보다 이전입니다.'
					)
				) {
					return false;
				}

				if (
					this.prerequisiteType === 7 &&
					!this.checkValidDate(
						this.joinDate.from,
						this.joinDate.to,
						'가입기간 종료일이 시작일보다 이전입니다.'
					)
				) {
					return false;
				}

				if (this.prerequisiteType === 1 && this.categoryTarget === 0) {
					const targetCategories = cloneDeep(this.targetCategories);
					this.reviewCategory = [];

					each(targetCategories, category => {
						category.idEventCategory = null;
					});

					each(this.targetCategories, category => {
						if (category.idFirstCategory !== null) {
							this.reviewCategory.push(category);
						}
					});

					if (
						this.reviewCategory.length !==
							this.targetCategories.length ||
						this.reviewCategory.length === 0
					) {
						alert('카테고리를 지정해 주세요.');
						return false;
					}
				}

				if (this.prerequisiteType === 6 && this.reviewerGrade === 2) {
					const targetCategories = cloneDeep(
						this.gradeTargetCategories
					);
					let secondaryValid;
					this.gradeCategory = [];

					each(targetCategories, category => {
						category.idEventCategory = null;
					});

					each(this.gradeTargetCategories, category => {
						if (category.idFirstCategory !== null) {
							this.gradeCategory.push(category);
						}
					});

					if (
						this.gradeCategory.length !==
							this.gradeTargetCategories.length ||
						this.gradeCategory.length === 0
					) {
						alert('카테고리를 지정해 주세요.');
						return false;
					}

					(() => {
						this.gradeCategory.forEach(item => {
							if (item.idSecondCategory === null) {
								secondaryValid = false;
								return;
							}
							secondaryValid = true;
						});
					})();

					if (!secondaryValid) {
						alert('2차 카테고리를 지정해 주세요');
						return false;
					}
				}

				if (this.reviewerGrade === 4) {
					if (
						this.gradeBrandList.length === 0 ||
						this.gradeBrandList.every(item => item.brandId === null)
					) {
						alert('브랜드 명을 입력해 주세요');
						return false;
					}
				}

				if (this.prerequisiteType === 7 && !this.joinDate.from) {
					alert('가입기간 시작날짜를 설정해주세요');
					return false;
				}

				if (this.prerequisiteType === 7 && !this.joinDate.to) {
					alert('가입기간 종료날짜를 설정해주세요');
					return false;
				}

				if (
					!this.validate(
						this.btnLinkText,
						'하단 버튼 문구를 입력해주세요'
					)
				) {
					return false;
				}

				if (this.prerequisiteType === 5) {
					if (
						!this.validate(
							this.linkValue,
							'하단 버튼 내용을 입력해주세요'
						)
					) {
						return false;
					}

					if (this.linkType === 'outlink') {
						if (!getRegexp('httpsUrl').test(this.linkValue)) {
							alert(
								'하단 버튼 내용이 https:// 로 시작하는 URL이 아닙니다.'
							);
							return false;
						}
					}
				}

				if (this.prerequisiteType !== 5) {
					if (this.applicationInfo.length === 0) {
						alert('신청방법을 최소 1개 이상 선택해 주세요');
						return false;
					}

					if (
						this.selectCheckbox('1') &&
						this.$refs.optionSelector.isEmptyValue()
					) {
						alert('신청 방법에 빈 입력란이 존재합니다');
						return false;
					}

					if (
						this.selectCheckbox('2') &&
						this.$refs.inputText.isEmptyValue()
					) {
						alert('신청 방법에 빈 입력란이 존재합니다');
						return false;
					}

					if (
						this.selectCheckbox('3') &&
						this.$refs.imageUpload.isEmptyValue()
					) {
						alert('신청 방법에 빈 입력란이 존재합니다');
						return false;
					}

					if (this.selectCheckbox('4')) {
						if (
							!this.validate(
								this.applySingleTitle,
								'신청 방법에 빈 입력란이 존재합니다.'
							)
						) {
							return false;
						}

						if (
							!this.validate(
								this.applySingleContext,
								'신청 방법에 빈 입력란이 존재합니다.'
							)
						) {
							return false;
						}
					}
				}

				if (this.isApply) {
					const applyData = [];
					const originTypeData = this.eventQuestionList.map(
						item => item.applyType
					);

					this.getApplyInfo().forEach(item => {
						applyData.push(item.applyType);
					});

					if (
						JSON.stringify(applyData) !==
						JSON.stringify(originTypeData)
					) {
						alert(
							'이미 이벤트를 참여한 유저가 있어 신청 정보 수정이 불가합니다.'
						);
						return false;
					}
				}

				if (
					!this.validate(
						this.bannerImagePath,
						'배너 이미지가 업로드되어 있지 않습니다'
					)
				) {
					return false;
				}

				if (
					!this.validate(
						this.eventContext,
						'이벤트 내용을 입력해 주세요'
					)
				) {
					return false;
				}

				if (this.prerequisiteType !== 5) {
					if (
						!this.validate(
							this.thirdAgreeCompany,
							'정보제공 업체를 입력해 주세요'
						)
					) {
						return false;
					}

					if (
						!this.validate(
							this.thirdAgreePurpose,
							'정보제공 목적을 입력해 주세요'
						)
					) {
						return false;
					}

					if (
						!this.validate(
							this.thirdAgreeInfo,
							'제공 정보를 입력해 주세요'
						)
					) {
						return false;
					}

					return !!this.validate(
						this.thirdAgreeDate,
						'보유 및 이용기간을 입력해 주세요'
					);
				}

				return true;
			},
			selectedBrandTarget(event, target) {
				this[target] = event;

				if (this.reviewerGrade === 4) {
					const brandList = cloneDeep(this.gradeBrandList);
					brandList.forEach(item => {
						item.brandId = item.idBrand;
						delete item.showSearchBrand;
						delete item.brandTitle;
						delete item.idBrand;
					});

					this.gradeBrandList = brandList;
				}
			},
			submitEvent() {
				if (!this.validations()) {
					return false;
				}

				const idRegister = getIdRegister();
				const confirmMessage =
					this.mode === 'register'
						? '이벤트를 등록하시겠습니까?'
						: this.eventType == 1
							? '이벤트를 수정하시겠습니까?'
							: '이벤트를 수정하시겠습니까?\n\n이벤트 수정 시 광고문구가 초기화됩니다.\n이벤트광고 메뉴에서 광고문구를\n다시 설정해 주시기 바랍니다.';
				const eventContent = {
					eventText: this.eventContext,
					...this.imageDto,
				};

				if (
					this.mode === 'modify' &&
					this.bannerImagePath !== this.prevImagePath
				) {
					const defaultImage =
						'https://dn5hzapyfrpio.cloudfront.net/event/3a2/3a2bfe20-d27d-11ed-be9e-0101574d30b7.png';
					if (this.prevImagePath !== defaultImage) {
						const imageHost = `${this.$store.state.env.IMAGE_STORAGE_PATH}`;
						imageRemove(this.prevImagePath.split(imageHost).pop());
					}
				}

				if (!confirm(confirmMessage)) {
					return false;
				}

				const eventQuestionList = this.getApplyInfo();
				const eventProduct = {
					idProducts: this.products.reduce((acc, product) => {
						acc.push(product.idProduct);
						return acc;
					}, []),
				};

				const thirdAgree = {
					thirdAgreeCompany:
						this.prerequisiteType === 5
							? null
							: this.thirdAgreeCompany,
					thirdAgreeDate:
						this.prerequisiteType === 5
							? null
							: this.thirdAgreeDate,
					thirdAgreeInfo:
						this.prerequisiteType === 5
							? null
							: this.thirdAgreeInfo,
					thirdAgreePurpose:
						this.prerequisiteType === 5
							? null
							: this.thirdAgreePurpose,
				};
				const isAllDate =
					this.prerequisiteType === 2
						? this.isAllDateForPurchase
						: this.isAllDate;

				let prerequisiteStartDate = '';
				let prerequisiteEndDate = '';

				switch (this.prerequisiteType) {
					case 1:
						prerequisiteStartDate = this.prerequisiteDate.from;
						prerequisiteEndDate = this.prerequisiteDate.to;
						break;
					case 2:
						prerequisiteStartDate = this.purchaseDate.from;
						prerequisiteEndDate = this.purchaseDate.to;
						break;
					case 7:
						prerequisiteStartDate = this.joinDate.from;
						prerequisiteEndDate = this.joinDate.to;
						break;
					default:
						break;
				}

				if (this.prerequisiteType === 1) {
					this.prerequisiteTarget =
						this.categoryTarget === 1 ? 'ALL' : 'CATEGORY_TARGET';
					this.eventCategories = [...this.reviewCategory];
				}

				if (this.prerequisiteType === 6) {
					switch (this.reviewerGrade) {
						case 0:
							this.prerequisiteTarget = 'ALL';
							break;
						case 1:
							this.prerequisiteTarget = 'CATEGORY_ALL';
							break;
						case 2:
							this.prerequisiteTarget = 'CATEGORY_TARGET';
							break;
						case 3:
							this.prerequisiteTarget = 'BRAND_ALL';
							break;
						case 4:
							this.prerequisiteTarget = 'BRAND_TARGET';
							break;
						default:
							break;
					}

					switch (this.gradeList) {
						case 1:
							this.prerequisiteLimit = 1;
							break;
						case 2:
							this.prerequisiteLimit = 6;
							break;
						case 3:
							this.prerequisiteLimit = 11;
							break;
						case 4:
							this.prerequisiteLimit = 21;
							break;
						case 5:
							this.prerequisiteLimit = 51;
							break;
						default:
							break;
					}

					if (this.prerequisiteTarget === 'CATEGORY_TARGET') {
						this.eventCategories = [...this.gradeTargetCategories];
					}
				}

				if (this.eventType !== 2) {
					this.activityDate = null;
				}

				if (this.eventType === 3) {
					this.products = [];
				}

				if (this.eventType === 6) {
					const fields = [
						{ type: 'info', key: 'mission1' },
						{ type: 'info', key: 'mission2' },
						{ type: 'info', key: 'mission3' },
						{ type: 'hash_tag', key: 'hashTag' },
						{ type: 'account_tag', key: 'accountTag' },
					];
					this.missionDoc = JSON.stringify({
						title: '미션 내용을 다시 한 번 확인해 주세요!',
						contentList: fields.map((field, index) => ({
							type: field.type,
							order: index + 1,
							text: this.mission[field.key],
						})),
					});
				} else {
					this.missionDoc = '';
				}

				const submitData = {
					eventQuestionList,
					eventProduct,
					idRegister,
					eventContent,

					idEvent: this.idEvent,
					hitsCount: 0,
					isDelete: false,
					isDisplay: this.isDisplay === 1,
					isHidden: this.isHidden === 0,
					eventTitle: this.eventTitle,
					eventDesc: this.eventDesc,
					startDate: moment(
						this.eventPeriod.from,
						'YYYY-MM-DDTHH:mm'
					).format('X'),
					endDate: moment(this.eventPeriod.to, 'YYYY-MM-DDTHH:mm')
						.endOf('minute')
						.format('X'),
					winnerIssueOn: this.winnerIssueOn
						? moment(this.winnerIssueOn, 'YYYY-MM-DD').format('X')
						: null,
					reviewEndAt: this.reviewEndAt
						? moment(this.reviewEndAt, 'YYYY-MM-DD').format('x')
						: null,
					winnerLimit: this.winnerLimit,
					clientType: this.clientType,
					clientName:
						this.clientType === 2
							? this.clientBrand.brandTitle
							: this.clientNameCustom,
					idBrand:
						this.clientType === 2 ? this.clientBrand.idBrand : null,

					isReply: this.isReply === 1,
					replyHolderText: this.replyHolderText,
					eventType: this.eventType,
					isAllDate: isAllDate === 1,
					activityDate: this.activityDate,
					prerequisiteType: this.prerequisiteType,
					prerequisiteStartDate:
						prerequisiteStartDate === ''
							? 0
							: moment(
									prerequisiteStartDate,
									'YYYY-MM-DDTHH:mm'
								).format('X'),
					prerequisiteEndDate:
						prerequisiteEndDate === ''
							? 0
							: moment(prerequisiteEndDate, 'YYYY-MM-DDTHH:mm')
									.endOf('minute')
									.format('X'),
					prerequisiteLimit: this.prerequisiteLimit,
					eventCategories: this.eventCategories,
					linkType: this.linkType,
					btnLinkText: this.btnLinkText,
					linkValue: this.linkValue,
					...thirdAgree,

					alertNoReviewStartOn: this.alertNoReviewPeriod.from
						? moment(this.alertNoReviewPeriod.from).valueOf()
						: null,
					alertNoReviewEndOn: this.alertNoReviewPeriod.to
						? moment(this.alertNoReviewPeriod.to)
								.add({ d: 1, s: -1 })
								.valueOf()
						: null,
					prerequisiteTarget: this.prerequisiteTarget,
					eventBrands:
						this.reviewerGrade === 4 ? this.gradeBrandList : [],
					candidateLimit: this.candidateLimit,
					missionDoc: this.missionDoc,
					brandInfo: this.brandInfo,
					productInfo: this.productInfo,
				};
				this.$store.commit('toggleSpinner', true);
				this.$axiosAdmin2
					.post('/api/events', submitData)
					.then(({ data }) => {
						if (!!data.idEvent) {
							alert(
								this.mode === 'register'
									? '등록되었습니다'
									: '수정되었습니다'
							);
						}

						this.$store.commit('toggleSpinner', false);
						this.$router.push('/events/list');
					})
					.catch(err => {
						console.error(err);
						alert(
							'데이터 전송중 오류가 발생했습니다.\n계속해서 문제가 발생할 경우 관리자에게 문의하여 주시기 바랍니다.'
						);
						this.$store.commit('toggleSpinner', false);
					});
			},
			onUpdateIsAllDate() {
				this.prerequisiteDate = { from: '', to: '' };
			},
			handleIsAllDateChange(value) {
				this.isAllDate = value;
				this.onUpdateIsAllDate();
			},
		},
	};
</script>
<style lang="scss" scoped>
	#app-main FORM.event {
		padding-top: 1em;

		& ::v-deep {
			select {
				border: 1px solid #ebebed;
				background: #fff;
				border-radius: 2px;
			}
		}

		.event__product-image {
			position: fixed;
			width: 100%;
			height: 100%;
			top: 0;
			left: 0;
			z-index: 999;
		}

		.event__product-image__background {
			position: absolute;
			width: 100%;
			height: 100%;
			background: rgba(0, 0, 0, 0.5);
		}

		.event__product-image__image {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate3d(-50%, -50%, 0);
		}

		.event__product-image__modal-close {
			position: absolute;
			top: -1em;
			right: -1em;
			width: 2em;
			height: 2em;
			border: 1px solid #000;
			border-radius: 50%;
			background: #fff;
			color: #000;
		}

		td {
			width: 50%;
			padding: 0.5em;
			&.event__grade {
				width: 73%;
			}
		}

		select {
			height: 36px;
		}

		.event__grade-select {
			margin: 10px;
		}

		.event-line {
			position: relative;
			padding: 0.5em 0;
		}
		.event-checkbox {
			margin-right: 1em;
		}

		.event__apply {
			margin-top: 50px;
		}

		.event-input--small {
			width: 100px;
		}

		.event-input--medium {
			width: 200px;
		}

		.event-input--large {
			width: 350px;
		}

		.event__productions {
			td,
			th {
				text-align: center;
				vertical-align: middle;
			}
		}

		.event__add-production {
			height: 36px;
			background: $btn-blue;
			color: #fff;
			font-weight: bold;
		}

		.event__productions__image {
			cursor: pointer;
		}

		.event__remove-product {
			background: #ff3860;
			font-size: 0.75rem;
			vertical-align: middle;
			width: 1.6em;
			height: 1.6em;
			border-radius: 50%;
			color: #fff;
		}

		.event__terms-label {
			margin-right: 1em;
		}

		.event__warn {
			color: #ff3860;
			font-weight: bold;
		}

		.inner-table {
			margin-top: 1em;
			border-top: 1px solid #ebebed;
			table-layout: fixed;

			&.event__apply {
				margin-top: 50px;
			}

			th {
				width: 100px;
			}
		}

		.event__activity-end-date {
			position: absolute;
			right: 20px;
			top: 50%;
			transform: translateY(-50%);
		}

		.event__button-wrapper {
			text-align: center;
			padding: 2em 0;

			.btn {
				display: inline-block;
				font-size: 1.5em;
				height: auto;
				padding: 0.5em 1em;
				border-radius: 1.5em;
				background: $btn-blue;
				color: #fff;
			}
		}

		.event__image-buttons-wrapper {
			text-align: right;
		}

		.event__image-cancel,
		.event__image-submit {
			font-size: 1em;
			font-weight: bold;
		}

		.event__image-submit {
			background: $btn-blue;
			color: #fff;
		}

		.event__button-wrapper {
			.btn-winner {
				background: #fff;
				color: $btn-blue;
			}
		}
	}
</style>
